<template>
  <div class="container-withdrawal-details">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.mybean.details') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="main">
      <!-- 时间 -->
      <div class="time-box">
        <div class="time-btn" @click="handleTimePop">
          <span>{{ handleMoment(chooseTime, 'YYYY-MM') }}</span>
          <img src="@/assets/packageAssets/common/arrow06.png" alt="" />
        </div>
      </div>
      <!-- 列表 -->
      <div class="list-wrapper">
        <div v-if="isLoading" class="loading-wrapper">
          <van-loading />
        </div>
        <template v-else>
          <div class="list-item" v-for="item in details" :key="item.id" @click="handleToStatusDetails(item)">
            <div class="logo-wrapper">
              <img :src="item.withdrawalMethodIcon | imgPath" alt="logo" width="40" />
            </div>
            <div class="left-info-wrapper">
              <p class="title">{{ item.withdrawalMethod || '' }}</p>
              <p class="date">{{ handleMoment(item.createTime, 'DD/MM HH:mm:ss') }}</p>
            </div>
            <div class="space"></div>
            <div class="right-info-wrapper">
              <div class="coins-wrapper">
                <span>{{ item.beansAmount }}</span>
                <img class="beans" :src="getMatchImg('beans')" alt="icon" width="16" height="16" />
              </div>
              <div class="status-wrapper">
                <i :class="withdrawStatusClass(item.state)">{{ withdrawStatusTxt(item.state) }}</i>
              </div>
            </div>
            <div class="more-wrapper">
              <img src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/default/more.png" alt="icon" width="12" height="12" />
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 选择器 -->
    <CTime :showPop="showPop" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import CTime from '@/components/CTime'
import { apiFetchWithdrawRecord } from '@/api/imee'

export default {
  components: { CTime },
  data() {
    const query = this.$route.query
    const localDate = sessionStorage.getItem('withdrawal-details-date') || ''
    sessionStorage.removeItem('withdrawal-details-date')
    return {
      barHeight: query.statusBarHeight || 38,
      walletType: query.walletType || 1,
      showPop: false,
      chooseTime: localDate || new Date(),
      details: [],
      isLoading: true
    }
  },
  mounted() {
    this.fetchInviteHistory()
  },
  methods: {
    withdrawStatusClass(state) {
      const classMap = {
        0: 'state0',
        1: 'state0',
        2: 'state2',
        3: 'state2',
        4: 'state0',
        5: 'state2',
        6: 'state2',
        7: 'state2',
        8: 'state0'
      }
      return classMap[state]
    },
    withdrawStatusTxt(state) {
      // 0 8 审核中, 1 4 审核驳回, 2 5 6 7打款中, 3 打款成功
      const stateTxtMap = {
        0: this.$t('lang.instantPayment.reviewing'),
        1: this.$t('lang.wd.state1'),
        2: this.$t('lang.instantPayment.paying'),
        3: this.$t('lang.instantPayment.success'),
        4: this.$t('lang.wd.state1'),
        5: this.$t('lang.instantPayment.paying'),
        6: this.$t('lang.instantPayment.paying'),
        7: this.$t('lang.instantPayment.paying'),
        8: this.$t('lang.instantPayment.reviewing')
      }
      return stateTxtMap[state] || '-'
    },
    // 打开日期选择
    handleTimePop() {
      this.showPop = true
    },

    // 选择当前的日期
    handleCurrentDate(val) {
      this.chooseTime = val
      this.fetchInviteHistory()
    },

    // 关闭弹框
    closePop() {
      this.showPop = false
    },

    // 获取详情
    async fetchInviteHistory() {
      try {
        this.isLoading = true
        const params = {
          walletType: this.walletType,
          limit: 500,
          offset: 0,
          ...this.getMonthStartAndEnd(this.chooseTime)
        }
        const res = await apiFetchWithdrawRecord(params)
        if (res) {
          this.details = res
        }
      } catch (error) {
      } finally {
        this.isLoading = false
      }
    },
    /**
     * @description 前往状态详情
     */
    handleToStatusDetails(item) {
      sessionStorage.setItem('withdrawal-details-date', this.chooseTime)
      this.$router.push({
        path: 'withdrawal-details-status',
        query: {
          withdrawId: item.withdrawId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .more-wrapper {
    transform: rotateY(180deg);
  }
}
</style>
